import { RegisterInput } from "@/happypaws-shared/src/Authentication/models/RegisterInput";
import { useMutation } from "@tanstack/react-query";
import { authService } from "services/auth.service";
import { useAuth } from "context/AuthContext";

export const useRegister = () => {
  const { setUser } = useAuth();

  return useMutation({
    mutationFn: (data: RegisterInput) => authService.register(data),
    onSuccess: (response) => {
      setUser(response);
    },
    onError: (error: any) => {
      console.error("Register error:", error);
    },
  });
};
